import LeaderOrderDetail from './LeadrOrderDetail/LeadrOrderDetail-container'
import './LeadrOrder.scss'

const LeaderOrder = (props: any) => (
  <div className="LeaderOrder p-3 pb-0">
    <LeaderOrderDetail isBulkOrder={props?.isBulkOrder} />
  </div>
)

export default LeaderOrder